<ib-not-auth-header></ib-not-auth-header>

<main class="w-full min-h-vh">
  <router-outlet></router-outlet>
</main>
